export default __webpack_public_path__ + "static/media/wsw.6112d09f.png";